import { render, staticRenderFns } from "./brickyViewer.vue?vue&type=template&id=a48e1d96&"
import script from "./brickyViewer.vue?vue&type=script&lang=js&"
export * from "./brickyViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports